import {
  GENERAL_PROMPT_REQUEST,
  GENERAL_PROMPT_SUCCESS,
  GENERAL_PROMPT_FAILURE,
  GENERAL_PROMPT_GET_REQUEST,
  GENERAL_PROMPT_GET_SUCCESS,
  GENERAL_PROMPT_GET_FAILURE,
} from "../types/generalPrompts.types";

const initialState = {
  postResponse: "",
  getResponse: "",
  error: "",
  loading: false,
  getLoading: false,
};

const GeneralPromptReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERAL_PROMPT_REQUEST:
      return {
        ...state,
        postResponse: "",
        loading: true,
      };
    case GENERAL_PROMPT_SUCCESS:
      return {
        ...state,
        postResponse: action.payload,
        loading: false,
      };
    case GENERAL_PROMPT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GENERAL_PROMPT_GET_REQUEST:
      return {
        ...state,
        getLoading: true,
      };
    case GENERAL_PROMPT_GET_SUCCESS:
      return {
        ...state,
        getResponse: action.payload,
        getLoading: false,
      };
    case GENERAL_PROMPT_GET_FAILURE:
      return {
        ...state,
        error: action.payload,
        getLoading: false,
      };
    default:
      return state;
  }
};

export default GeneralPromptReducer;
